import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmType } from '../interfaces/IKnmType';

export async function fetchKnmTypes(enabled_248?: boolean): Promise<IKnmType[]> {
  return apiGet<IKnmType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-types${
      typeof enabled_248 === 'boolean' ? `?enabled_248=${enabled_248}` : ''
    }`,
  );
}

export async function fetchKnmTypesByKnoAndSupervision(
  knoVersionId?: string,
  supervisionVersionId?: string,
  enabled_248?: boolean,
): Promise<IKnmType[]> {
  const queryParams = new URLSearchParams();

  knoVersionId && queryParams.append('knoVersionId', knoVersionId);
  supervisionVersionId && queryParams.append('supervisionVersionId', supervisionVersionId);
  enabled_248 && queryParams.append('enabled_248', enabled_248.toString());

  return apiGet<IKnmType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-types${
      queryParams.toString().length ? `?${queryParams}` : ''
    }`,
  );
}
